/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Defect_Qty_LabelInputs */

const vi_confirm_return_defect_qty_label = /** @type {(inputs: Confirm_Return_Defect_Qty_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SL lỗi`)
};

/**

* @param {Confirm_Return_Defect_Qty_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_defect_qty_label = /** @type {((inputs?: Confirm_Return_Defect_Qty_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Defect_Qty_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_defect_qty_label(inputs)
});